// extracted by mini-css-extract-plugin
export default {"modal-wrapper":"DeleteMediaModal_modal-wrapper__YuW7l"};